/* Publish by EComposer at 2026-09-30 09:17:55*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kgipj0998ah"]=  window.__ectimmers["ecom-kgipj0998ah"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-kgipj0998ah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kgipj0998ah', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nsfxv08ocx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nsfxv08ocx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-miem1i9sdzr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-miem1i9sdzr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-focowaxku1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-focowaxku1', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kmsiwn1pl2"]=  window.__ectimmers["ecom-kmsiwn1pl2"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-kmsiwn1pl2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmsiwn1pl2', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6c132q7013v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6c132q7013v', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gh5ysemzxw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gh5ysemzxw', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}